/* eslint-disable quote-props */
import { Theme } from "@mui/material";

export const drawerStyle = (theme: Theme) => ({
  [theme.breakpoints.down("sm")]: {
    top: "59px",
  },
  "& .MuiDrawer-paper": {
    background: "#FAF6F4",
    borderRight: "none",
    display: "grid",
    boxShadow: "none",
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      top: "58px",
      height: "calc(100% - 59px)",
    },
  },
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    [theme.breakpoints.down("sm")]: {
      top: "59px",
    },
  },
});
